import { connect } from 'react-redux';
import { compose } from 'redux';

import { simoSubPage } from 'decorators/subPage';
import { toggleAutoRenew } from 'actions/simoSubs';
import { getSubmitStatus } from 'reducers';
import AutoRenew from 'components/simo/AutoRenew';

const mapStateToProps = (state, { subId, sub }) => ({
  initialValues: { renewal_enabled: Boolean(sub && sub.renewal_enabled) },
  saveStatus: getSubmitStatus(state, 'autoRenew'),
});

const mapDispatchToProps = (dispatch, { subId, sub }) => ({
  onSubmit: (values) => {
    if (sub && sub.renewal_enabled !== values.renewal_enabled) {
      return toggleAutoRenew(subId)(dispatch);
    }
  },
});

export default compose(simoSubPage)(
  connect(mapStateToProps, mapDispatchToProps)(AutoRenew),
);
